import { getMessaging, getToken } from "firebase/messaging";
import { getFromStorage, setToStorage } from "../helpers/storage";
import { app } from "./firebaseKeys";
import { STORAGE_KEYS } from "../helpers";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const swRegistration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BLtDoS2oJPW2cxTcxe_nPnO9vzmeFwK1g1KXhETAHCljX02TC8nMddp69iUg_sKjKpkPSAv0WptMe3055szLPhE",
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.warn("Notification permission not granted.");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
